import { withApollo } from "lib/apollo3";
import { withAuth } from "lib/auth";
import { withContext } from "lib/context";
import { withGlobalComponents } from "shared-components/ViewFragments/GlobalComponents/web";
import { withTranslation } from "shared-components/i18n";
import { PageLayout } from "src/Components/Layout/web";
import AboutUs from "src/Components/ViewFragments/AboutUs";

const Nosotros = () => {

    return (
        <PageLayout classContainer="landingApp">
            <AboutUs />
        </PageLayout>
    );
};

export default withApollo(
    withContext(withTranslation(withGlobalComponents(Nosotros)), {
        withDummyContext: false,
        withFiltersContext: false,
        withConfigContext: true,
        withThemeContext: true,
    })
);
